import { IMLThamSoPhongHocMonHocActionTypes } from "../../action-types/category/IMLThamSoPhongHocMonHocActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMLThamSoPhongHocMonHocReducer } from "../../reducer-model/category/IMLThamSoPhongHocMonHocReducer";

const initState: IMLThamSoPhongHocMonHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mlThamSoPhongHocMonHocs: [],
};
export const mlThamSoPhongHocMonHocReducer = (
  state: IMLThamSoPhongHocMonHocReducer = initState,
  action: IMLThamSoPhongHocMonHocActionTypes
): IMLThamSoPhongHocMonHocReducer => {
  switch (action.type) {
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, mlThamSoPhongHocMonHocs: action.payload };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, mlThamSoPhongHocMonHocEditing: action.payload };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "ML_THAM_SO_PHONG_HOC_MON_HOC_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
